// src/components/LoginScreen.jsx
import React, { useState } from 'react';
import { signInWithEmailAndPassword, GoogleAuthProvider, signInWithPopup } from 'firebase/auth';
import '../App.js'

export default function LoginScreen( {setIsLoggedIn, auth} ) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  // 1. Hand-built Email/Password Login Function
  const handleEmailLogin = async (e) => {
    e.preventDefault();
    try {
      await signInWithEmailAndPassword(auth, email, password);
    } catch (err) {
      alert(err.message);
    }
  };

  // 2. Hand-built Google OAuth Login Function
  const handleGoogleLogin = async () => {
    const provider = new GoogleAuthProvider();
    try {
      await signInWithPopup(auth, provider); // Opens a clean, secure Google auth overlay
    } catch (err) {
      alert(err.message);
    }
  };

  return (
    <div className="App-Login">
        <div className="min-h-screen flex items-center justify-center bg-gray-50 p-4">
        <div className="w-full max-w-sm bg-white p-8 rounded-xl shadow-md border">
            <h2 className="text-2xl font-bold text-gray-800 text-center mb-6">Welcome to Thaelos</h2>

            {/* Custom Native Google OAuth Button */}
            <button 
            onClick={handleGoogleLogin}
            className="w-full flex items-center justify-center gap-2 border p-2.5 rounded-lg font-medium text-gray-700 hover:bg-gray-50 transition mb-4"
            >
            {/* <img src="https://gstatic.com" alt="Google" className="w-5 h-5" /> */}
            Continue with Google
            </button>

            <div className="relative my-5 text-center text-xs text-gray-400 before:content-[''] before:absolute before:left-0 before:top-1/2 before:w-5/12 before:border-t after:content-[''] after:absolute after:right-0 after:top-1/2 after:w-5/12 after:border-t">
            OR
            </div>

            {/* Custom Standard Form Elements */}
            <form onSubmit={handleEmailLogin} className="space-y-4">
            <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Email address</label>
                <input 
                type="email" value={email} onChange={(e) => setEmail(e.target.value)}
                className="w-full p-2 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:outline-none" required 
                />
            </div>
            <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Password</label>
                <input 
                type="password" value={password} onChange={(e) => setPassword(e.target.value)}
                className="w-full p-2 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:outline-none" required 
                />
            </div>
            <button className="w-full bg-blue-600 text-white p-2.5 rounded-lg font-medium hover:bg-blue-700 transition">
                Sign In
            </button>
            </form>
        </div>
        </div>
    </div>
  );
}